import { Deposit, FormCondition } from '@urbanx/agx.campaigns.client';
import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import ConditionDateText from './ConditionDateText';

interface ConditionDateProps {
  id?: string;
  condition: FormCondition | Deposit;
  isDeposit?: boolean;
  depositAmount?: number;
  specialConditionIdToClauseNumberMap: {
    [key: string]: string;
  };
}

const ConditionDate = ({
  id,
  condition,
  isDeposit = false,
  depositAmount,
  specialConditionIdToClauseNumberMap,
}: ConditionDateProps) => {
  return (
    <AgxSpacer direction="horizontal" gap="spacing-md" fill contentAlignment="center">
      <AgxTypography id={`${id}-info`} type="body_ui" size="small" color="var(--text-primary)">
        <ConditionDateText
          condition={condition}
          isDeposit={isDeposit}
          depositAmount={depositAmount}
          specialConditionIdToClauseNumberMap={specialConditionIdToClauseNumberMap}
        />
      </AgxTypography>
    </AgxSpacer>
  );
};

export default ConditionDate;
